import { Button, Divider, Stack } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import SMEName from './SMEName';
import { SMEExternal, SMEInternal } from 'types/lcms/courses';
import DataTables from 'components/DataTables';
import MaterialLink from './MaterialLink';
import Badge from 'components/Badge';
import MaterialInputDataForm from '../courseEntry/MaterialInputDataForm';
import { useDisclosure } from '@mantine/hooks';
import { IconArrowBackUp } from '@tabler/icons-react';
import { HiOutlinePlus } from 'react-icons/hi';
import { useQueryClient } from '@tanstack/react-query';

const AdminSMEItem = ({
  item,
  courseId,
  noBadge = false
}: {
  item: (SMEInternal | SMEExternal) & { smeId: string; type: string };
  courseId: string;
  noBadge?: boolean;
}) => {
  const queryClient = useQueryClient();
  const [openedAddSection, { open: openAddSection, close: closeAddSection }] = useDisclosure(false);

  const styleBadge = (status: string) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return 'info';
      case 'approved':
        return 'success';
      default:
        return 'error';
    }
  };

  return (
    <Card radius={6} p={24}>
      <Stack>
        <SMEName
          name={item.name}
          type={item.type}
          subtitle={(item as SMEInternal).binusianID || (item as SMEExternal).email || '-'}
          linkURL={item?.linkURL || '#'}
          noBadge={noBadge}
        />
        <Divider />
        <Stack gap={8}>
          <Button
            fullWidth
            variant={openedAddSection ? 'default' : 'outline'}
            leftSection={openedAddSection ? <IconArrowBackUp /> : <HiOutlinePlus />}
            onClick={() => (openedAddSection ? closeAddSection() : openAddSection())}
          >
            {openedAddSection ? 'Cancel' : 'Add Material'}
          </Button>
          {openedAddSection && (
            <MaterialInputDataForm
              courseId={courseId}
              SMEId={item.smeId}
              onSubmit={(_data) => {
                queryClient.invalidateQueries({ queryKey: ['lcmsDetail', courseId] });
              }}
              onCancel={closeAddSection}
              role='admin'
            />
          )}
        </Stack>
        <DataTables
          columns={[
            {
              heading: 'Link Material',
              props: ({ linkMaterial }: { linkMaterial: string }) => (
                <MaterialLink linkMaterial={linkMaterial} />
              ),
              active: true
            },
            {
              heading: 'Status',
              props: ({ approval }: { approval: 'Approved' | 'Rejected' }) => (
                <Badge variant={styleBadge(approval)}>{approval}</Badge>
              ),
              active: true
            }
          ]}
          data={item?.listMaterial || []}
          withBulkData
          emptyMessage='No material available'
        />
      </Stack>
    </Card>
  );
};

export default AdminSMEItem;
